module.exports = __webpack_public_path__ + "static/media/arrow-down2.31d61728.svg";